module.exports = __webpack_public_path__ + "img/upload_selected.a539fd52.png";